import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dashboard/listings/")({
  head: () => routeHead("/uk/dashboard/listings/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/my-listings-v2", statusCode: 301, replace: true });
  },
});
